import React  , { Component } from 'react'

import {  HomeSlider,
          HomeDeals       } from '../../Components/UI/UI'

import { getWeather, asyncgetWeather } from "../../Utility/Utility";

import Menu from '../../Components/Menu/Menu'
import Footer from '../../Components/Footer/Footer'



class SpacielDeals extends Component {

  state = {
   
    telAvivWeather : 0,
    waterTemp : 0,
    jerusalemWeather : 0,

  }

  componentDidMount () {
   
    Promise.all([ asyncgetWeather() ]).then( response => {
      const weather = response[0];
        this.setState({
          jerusalemWeather  : weather.jerusalem.temperature,
          telAvivWeather    : weather.telaviv.temperature,
          waterTemp         : weather.telaviv.water_temp
        })
    });
  
    window.addEventListener("resize", this.updateDimensions);
  }
  
  render(){
    return(
      <div className="page align-center page-SpacielDeals">
        <Menu />
        <HomeSlider isHomeSlider={true} waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather} />
        <HomeDeals />
        <Footer />
      </div>
    )
  }

}



export default SpacielDeals


// WEBPACK FOOTER //
// ./src/Pages/SpacielDeals/SpacielDeals.js